module.exports = __webpack_public_path__ + "d2739080.png";